import React, { useState, useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "./main.scss";
import About from "./components/pages/about/about";
import Service from "./components/pages/service/service";
import Client from "./components/pages/clients/client";
import Footer from "./components/footer/footer";
import Loader from "./components/loader/loader";
import Video from "./components/pages/video/video";
import Intel from "./components/pages/intelligence/intel";
import Digital from "./components/pages/digital/digital";
import Design from "./components/pages/design/design";
import Api from "./components/pages/api_developement/review";
import Cloud from "./components/pages/cloud/cloud";
import Header from "./components/header/header";
import Home from "./components/pages/home/home";
import Partner from "./components/pages/Partnership/Partner";
import Whypartner from "./pages/PartnerwithUs/Whypartner";
import CustomerIdentity from "./components/pages/HomeCustomerIdentity/CustomerIdentity";
import HdigitalIdentity from "./components/pages/HomeDigitalIdentity/HdigitalIdentity";
import IdentityGovernance from "./components/pages/IdentityGovernance/IdentityGovernance";
import WhoWeAre from "./components/pages/Who-We-Are/WhoWeAre";
import WhyWeStandOut from "./components/pages/Why-WeStand-Out/WhyWeStandOut";
import UpcomingEvents from "./components/pages/UpcomingEvents/upcoming-events";
import ClientTestimonial from "./components/pages/Testimonial/ClientTestimonial";

export default function Main() {
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_API}api/home-banner`);
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        const result = await response.json();
        setData(result); // Update state with API response
      } catch (error) {
        // setError(error.message); 
      } finally {
        setLoading(false); // Stop loading indicator
      }
    };

    fetchData();
  }, []);

  return (
    <section className="main_full">
      {loading ? (
        <Loader />
      ) : (
        <>
          <Header />
          <Home data={data} />
         
          <WhoWeAre data={data}/>
          <WhyWeStandOut data={data}/>
          <Service data={data}/>
          <Partner data={data}/>
          <Video data={data}/>
          <Client data={data} />
         
          <Footer />
        </>
      )}
    </section>
  );
}
